module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/ponderosa_bw-p-1080-0a74ceb2ea52acae3705694c4adcf140.jpg";